// PSR Related Options
export const psrTypeOptions = [
  { value: "COLLECT", label: "Collect" },
  { value: "REQUIRED", label: "Required" }
];


export const personsOptions = [
  { value: "all", label: "All" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" }
];

export const sourceOptions = [
  { label: "LPO", value: "LPO" },
  { label: "Site", value: "SITE" },
  { label: "Site/CIRB", value: "SITE/CIRB" },
  { label: "PO", value: "PO" },
  { label: "RSS", value: "RSS" },
  { label: "DTL", value: "DTL" },
  { label: "Industry Collaborator", value: "INDUSTRY_COLLABORATOR" },
  { label: "CTEP/DCP", value: "CTEP/DCP" },
  { label: "CTA Holder", value: "CTA_HOLDER" },
  { label: "IROC", value: "IROC" },
  { label: "Registration Data", value: "REGISTRATION_DATA" },
  { label: "CIRB", value: "CIRB" }
];

// Common Yes/No Options
export const yesNoOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" }
];

export const evaluationByGroupOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" }
];

// IRB Review Options
export const levelIrbReviewOptions = [
  { value: "Full", label: "Full" },
  { value: "Expedited", label: "Expedited" }
];

export const whenExpeditedReviewAllowedOptions = [
  {
    value: "Initial and continuing reviews",
    label: "Initial and continuing reviews"
  },
  {
    value: "Continuing reviews only",
    label: "Continuing reviews only"
  }
];

export const ctsuCollectionRequiredOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false }
];

export const collectIrbApprovalPostClosureOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false }
];

// Regulatory Review Options
export const regReviewCompletedYnOptions = [
  { label: "No issues", value: true },
  { label: "Issues found (Provide Comments)", value: false }
];

// OHRP Categories
export const ohrpCategoriesOptions = [
  { value: "1", label: "1" },
  { value: "1a", label: "1a" },
  { value: "1b", label: "1b" },
  { value: "2", label: "2" },
  { value: "2a", label: "2a" },
  { value: "2b", label: "2b" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8a", label: "8a" },
  { value: "8b", label: "8b" },
  { value: "8c", label: "8b" },
  { value: "9", label: "9" },
  { value: "Allowed per LPO", label: "Allowed per LPO" }
];

// IND Holder Options
export const indHolderOptions = [
  { value: "CTEP Held IND", label: "CTEP Held IND" },
  { value: "IDE", label: "IDE" },
  { value: "IDE Exempt", label: "IDE Exempt" },
  { value: "IND Exempt", label: "IND Exempt" },
  { value: "No Agent", label: "No Agent" },
  { value: "Non-CTEP Held IND", label: "Non-CTEP Held IND" }
];

// Request Type Options
export const requestTypeOptionsForReg = [
  { value: "AMENDMENT", label: "Amendment" },
  { value: "CORRECTION", label: "Correction" },
  { value: "NEW_SUBMISSION", label: "New submission" }
];
